import gql from 'graphql-tag';

export const RESTART_STAGE_MUTATION = gql`
  mutation RestartStageMutation($stageId: Int!, $memberIds: [Int!]!) {
    success: restartStage(data: {
      stageId: $stageId
      memberIds: $memberIds
    })
  }
`;
